import React from "react";

import { OTHER_OPTION_ISO, OTHER_OPTION_SBA } from "../../../constants.js";

export default function HeaderGroupAdditionalOptions({ options, setOptions }) {
  const handleChangeGroupCheckbox = (e) => {
    setOptions((prevState) => {
      if (prevState.otherOptions.includes(Number(e.target.value))) {
        return {
          ...prevState,
          otherOptions: prevState.otherOptions.filter((option) => option !== Number(e.target.value)),
        };
      } else {
        return {
          ...prevState,
          otherOptions: [...prevState.otherOptions, Number(e.target.value)],
        };
      }
    });
  };
  return (
    <>
      <br />

      <label className="set-aside-group-name">
        <input
          className="isoCheckBox"
          type="checkbox"
          id="isogroup"
          role="checkbox"
          name="filterValue"
          value={OTHER_OPTION_ISO}
          onChange={handleChangeGroupCheckbox}
          checked={options.otherOptions.includes(OTHER_OPTION_ISO)}
        />
        <a
          href="/iso_20243.shtml"
          id="isoDetails"
          title="select to see more details about ISO-20243"
          target="_blank"
          className="isoLinkDisplay"
        >
          ISO-20243
        </a>{" "}
        Certified
      </label>

      <br />

      <label className="set-aside-group-name">
        <input
          className="sbaWosbCheckBox"
          type="checkbox"
          id="sbawosbgroup"
          role="checkbox"
          name="filterValue"
          value={OTHER_OPTION_SBA}
          onChange={handleChangeGroupCheckbox}
          checked={options.otherOptions.includes(OTHER_OPTION_SBA)}
        />
        <a
          href="/WOSBs.shtml"
          id="sbaWosbDetails"
          title="select to see more details about SBA-certified WOSBs"
          target="_blank"
          className="sbaWosbLinkDisplay"
        >
          SBA
        </a>{" "}
        Certified WOSBs
      </label>
    </>
  );
}
